import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/system/indices/rotation/strategies", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function configSchema(strategy, requestOptions) {
  return __request__("GET", `/system/indices/rotation/strategies/${strategy}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
